import { ModelTier } from './types';

export const getModelTier = (modelTiers: Record<string, ModelTier>, id: string) => {
  let defaultTier = '';
  let tier = '';
  Object.keys(modelTiers).forEach((key) => {
    if (modelTiers[key].default) defaultTier = key;
    if (modelTiers[key].regString && id === modelTiers[key].regString) tier = key;
    if (modelTiers[key].regExp && new RegExp(modelTiers[key].regExp).test(id)) tier = key;
    if (
      modelTiers[key].models?.some(
        (model) => model.trim().toUpperCase() === id.trim().toUpperCase(),
      )
    )
      tier = key;
  });
  return tier || defaultTier || 'UNKNOWN';
};
